import moment from "moment";
import JSBI from 'jsbi';

export const formatPodDateTime = (dateString) => {
  const currentDate = moment(dateString).local();
  const date = currentDate.format("DD MMM YYYY");
  const time = currentDate.format("HH:mm");

  return { date, time, currentDateString: currentDate };
};

export const formatUtcToLocal = (utcDateString) => {
  const localDateTime = moment.utc(utcDateString).local();
  const date = localDateTime.format("DD MMM YYYY");
  const time = localDateTime.format("HH:mm");

  return { date, time, localDateTimeString: localDateTime };
};

export const getCountdown = (targetTime) => {
  const now = moment();
  const target = moment(targetTime);
  const diff = moment.duration(target.diff(now));

  if (diff.asSeconds() <= 0) {
    return { timeLeft: "LIVE", isLive: true };
  }

  const days = Math.floor(diff.asDays());
  const hours = diff.hours();
  const minutes = diff.minutes();

  const timeLeft = [
    days > 0 ? `${days}d` : "",
    hours > 0 ? `${hours}h` : "",
    minutes > 0 ? `${minutes}m` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return { timeLeft, isLive: false };
};

export const extractUnixTimestamp = (postId) => {
  if (postId == null) return "";

  try {
        // Convert to JSBI to handle large numbers
        const id = JSBI.BigInt(postId);
        
        // LinkedIn appears to use Unix epoch (January 1, 1970) with millisecond precision
        // Try different extraction methods to find the correct timestamp
        
        // Method 1: Extract first 42 bits and treat as milliseconds since Unix epoch
        const method1Timestamp = JSBI.toNumber(JSBI.signedRightShift(id, JSBI.BigInt(22)));
        
        // Method 2: Extract first 41 bits as seconds, then convert to milliseconds
        const method2Timestamp = JSBI.toNumber(JSBI.signedRightShift(id, JSBI.BigInt(23))) * 1000;
        
        // Method 3: Different bit shift (common in snowflake-like IDs)
        const method3Timestamp = JSBI.toNumber(JSBI.signedRightShift(id, JSBI.BigInt(12)));
        
        // Choose the method that gives a reasonable timestamp (between 2015-2025)
        const now = Date.now();
        const minTime = new Date('2015-01-01').getTime();
        const maxTime = new Date('2025-12-31').getTime();
        
        let finalTimestamp;
        
        if (method1Timestamp >= minTime && method1Timestamp <= maxTime) {
            finalTimestamp = method1Timestamp;
        } else if (method2Timestamp >= minTime && method2Timestamp <= maxTime) {
            finalTimestamp = method2Timestamp;
        } else if (method3Timestamp >= minTime && method3Timestamp <= maxTime) {
            finalTimestamp = method3Timestamp;
        } else {
            // If none work, try subtracting from current time (reverse engineering)
            const possibleAge = Math.abs(method1Timestamp - now);
            if (possibleAge < now - minTime) {
                finalTimestamp = now - possibleAge;
            } else {
                finalTimestamp = method1Timestamp; // fallback
            }
        }
        
        return finalTimestamp
        
    } catch (error) {
        throw new Error(`Invalid LinkedIn post ID: ${postId}`);
    }
};

export const unixTimestampToHumanDate = (timestamp) => {
  const dateObject = new Date(timestamp);
  return dateObject;
};

export { normalizeLinkedInUrl, TRACKING_QUERY_PARAMS } from "./utils/urlNormalization";
